/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { useEffect, useState } from "react";
import { getClientAll } from "../../../../../../services/clientService";
import { getRoleAll } from "../../../../../../services/roles";
import { getUnitBranchAllSimple } from "../../../../../../services/unitBranchService";
import { Loading } from "../../../../../components/Loadings/loading";
import { getCompanyAll } from "../../../../../../services/companyService";
import { LoadingSpan } from "../../../../../components/Loadings/loadingSpan";
import { KTSVG } from "../../../../../../../_metronic/helpers";
import { updatePasswordOne } from "../../../../../../services/usersService";
import { useToast } from "../../../../../components/Toats";
import { SelectGlobal } from "../../../../../components/SelectGlobal";
import { useQuery } from "react-query";


const StepModal = ({
  data, 
  updateData, 
  hasError, 
  formik, 
  handleClose, 
  id,
  setMyUserPassword,
  setTypeModalPassword,
  setShowCreateAppModalDelete,

}: any) => {
  const { toggleToast } = useToast();
  const [roleSelect, setRoleSelect] = useState<any>(formik.values.role ? formik.values.role : "");
  const [loadingPassword, setLoadingPassword] = useState<boolean>(false);
  

  const { data: clients = [], isLoading: loadingClients } = useQuery<any>(
    ["getClientsUserModal", formik.values.idUnitBranch],
    async () => {
      const myClients = await await getClientAll(formik.values.idUnitBranch, false, id)
      return myClients;
    },
    {
      onError: (error) => {
        console.log(error);
        toggleToast("Erro ao buscar a lista de unidades filiais ", "error")
      },
    }
  )

  const { data: unitBranchs = [], isLoading: loadingUnitBranch } = useQuery<any>(
    ["getMyUnitBranchUserModal"],
    async () => {
      const myUnitBranchs = await getUnitBranchAllSimple()
      return myUnitBranchs;
    },
    {
      onError: (error) => {
        console.log(error);
        toggleToast("Erro ao buscar a lista de unidades filiais ", "error")
      },
    }
  )

  const { data: companies = [], isLoading: loadingCompanies } = useQuery<any>(
    ["getMyCompaniesUserModal"],
    async () => {
      const myCompanies = await getCompanyAll()
      return myCompanies;
    },
    {
      onError: (error) => {
        console.log(error);
        toggleToast("Erro ao buscar empresas ", "error")
      },
    }
  )

  const { data: roles = [], isLoading: loadingRoles } = useQuery<any>(
    ["getMyRolesUserModal"],
    async () => {
      const myRoles = await await getRoleAll()
      return myRoles;
    },
    {
      onError: (error) => {
        console.log(error);
        toggleToast("Erro ao buscar os tipos de usuário. ", "error")
      },
    }
  )

  const postReenvioSenha = async (email: string) => {
    try {
      setLoadingPassword(true)
      const body = {
        email: email
      }
      const result = await updatePasswordOne(body)
      if(result){
        const myResult = {
          email: email,
          senha: result.senha ? result.senha : ""
        }
        setMyUserPassword?.(myResult)
        setTypeModalPassword?.('reenvio')
        setShowCreateAppModalDelete?.(true)
      }
    } catch (error) {
      console.log(error)
      toggleToast("Erro ao redefinir a senha do usuário. ", "error")

    }finally{
      setLoadingPassword(false)
    }
  }

  useEffect(() => {
    setRoleSelect(formik.values.role)
  }, [formik.values.role])

  if (loadingRoles) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', height: '15rem', alignItems: 'center'}}>
        <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>
      </div>
    );
  }

  return (
    <div className='current' data-kt-stepper-element='content' >
      <div className='w-100'>      
        <div style={{display: 'flex', gap: '1rem', marginTop: '0rem'}}>
          <div className='fv-row mb-10' style={{flex: '1'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Name</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Digite um nome para a unidade(filial)'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='name'
              placeholder=''
              value={formik.values.name}
              onChange={formik.handleChange("name")}
            />
            {!formik.values.companyName && hasError && (
              <div className='fv-plugins-message-container'>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  Informe um nome para o usuário
                </div>
              </div>
            )}
          </div>

          <div className='fv-row mb-10' style={{flex: '1'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>E-mail</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Digite um e-mail para o9 usuário'
              ></i>
            </label>
            <input
              type='email'
              className='form-control form-control-lg form-control-solid'
              name='email'
              placeholder='name@example.com'
              value={formik.values.email}
              onChange={formik.handleChange("email")}
              
            />
            {!formik.values.emailCompany && hasError && (
              <div className='fv-plugins-message-container'>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  O e-mail é obrigatório!
                </div>
              </div>
            )}
          </div>

          {id && <div className='fv-row mb-10' style={{display: 'flex', alignItems: 'end'}}>
            <button
              type='button'
              className='btn btn-lg btn-primary'
              disabled={loadingPassword}
              //data-kt-stepper-action='submit'
              onClick={() => {
                postReenvioSenha(formik.values.email ? formik.values.email : "")
              }}
            >
              Reenviar Senha
              {
                loadingPassword ? 
                  <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                :
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr064.svg'
                    className='svg-icon-3 ms-2 me-0'
                  />
              }
          </button>
          </div>}
        </div>

        <div className='mb-7'>
          <label className='required fw-bold fs-6 mb-5'>Role</label>
          {roles && roles.length > 0  && (
            roles.map((role: any) => {
              return (
                <div className=''>
                  <div className='form-check form-check-custom form-check-solid'>
                    <input
                      className='form-check-input me-3'
                      {...formik.getFieldProps('role')}
                      name='role'
                      type='radio'
                      value={role.slug}
                      id='kt_modal_update_role_option_0'
                      onChange={(e: any) => {
                        setRoleSelect(e.target.value)
                        formik.handleChange("role")(e)
                      }}
                      checked={formik.values.role == `${role.slug}`}
                      //disabled={formik.isSubmitting || isUserLoading}
                    />
                    <label className='form-check-label' htmlFor='kt_modal_update_role_option_0'>
                      <div className='fw-bolder text-gray-800'>{role.slug}</div>
                      <div className='text-gray-600'>
                        {role.description}
                      </div>
                    </label>
                  </div>
                  <div className='separator separator-dashed my-5'></div>
                </div>
              )
            })
          )}
          
          
        </div>
        

        {(roleSelect === "CLIENTE" || roleSelect === "FILIAL") && (
          <div style={{marginTop: '3.5rem'}}>
            <div style={{marginBottom: '2rem'}}>
              <h3 className='card-title' style={{display: 'flex', flexDirection: 'column'}}>
                  <span className='card-label fw-bold fs-3 mb-1'>Unidade (FILIAL) {" "}</span>
                  <span className='text-muted mt-1 fw-semibold fs-5'>Unidade FILIAL vinculada ao usuário</span>
              </h3>
            </div>

            <div>
              <div className='fv-row mb-10'>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                  <span>Lista de Unidades (FILIAL)</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Selecione para qual unidade filial essa credencial será vinculada. '
                  ></i>
                </label>
                <div>
                  <SelectGlobal 
                    itens={unitBranchs}
                    buttonAll={true}
                    textSearch={`Buscar por nome da unidade`}
                    textButtonInit={`Selecione a unidade FILIAL`}
                    labelKey={`companyName`}
                    valueKey='id'
                    value={formik.values.idUnitBranch}
                    className={"w-100"}
                    loading={loadingUnitBranch}
                    onChange={formik.handleChange("idUnitBranch")}
                    //onChange={(value: any) => {formik.setValues({...formik.values, idUnitBranch: value})}}
                  />


                  {!formik.values.idUnitBranch && hasError ? (
                      <div className='fv-plugins-message-container'>
                        <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                          A unidade FILIAL é obrigatória!
                        </div>
                      </div>
                    ) : <></>}
                </div>
              </div>
            </div>
          </div>
        )}

        {roleSelect === "EMPRESA" && (
          <div style={{marginTop: '3.5rem'}}>
            <div style={{marginBottom: '2rem'}}>
              <h3 className='card-title' style={{display: 'flex', flexDirection: 'column'}}>
                  <span className='card-label fw-bold fs-3 mb-1'>Empresa {" "}</span>
                  <span className='text-muted mt-1 fw-semibold fs-5'>Empresa vinculada ao usuário</span>
              </h3>
            </div>

            <div>
              <div className='fv-row mb-10'>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                  <span>Lista de Empresas</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    //title='Selecione para qual unidade filial essa credencial será vinculada. '
                  ></i>
                </label>
                <div>
                  <SelectGlobal 
                    itens={companies}
                    buttonAll={true}
                    textSearch={`Buscar por nome da corporação`}
                    textButtonInit={`Selecione a empresa`}
                    labelKey={`corporateName`}
                    valueKey='id'
                    value={formik.values.idCompany}
                    className={"w-100"}
                    loading={loadingCompanies}
                    onChange={formik.handleChange("idCompany")}
                />
                </div>
              </div>
            </div>
          </div>
        )}

        {roleSelect === "CLIENTE" && (
          <div style={{marginTop: '3.5rem'}}>
              <div style={{marginBottom: '2rem'}}>
                <h3 className='card-title' style={{display: 'flex', flexDirection: 'column'}}>
                    <span className='card-label fw-bold fs-3 mb-1'>Clientes {" "}</span>
                    <span className='text-muted mt-1 fw-semibold fs-5'>Cliente vinculado ao usuário</span>
                </h3>
              </div>

              <div>
                <div className='fv-row mb-10'>
                  <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                    <span>Lista de clientes disponíveis (sem usuário)</span>
                    <i
                      className='fas fa-exclamation-circle ms-2 fs-7'
                      data-bs-toggle='tooltip'
                      title='Selecione para qual unidade filial essa credencial será vinculada. '
                    ></i>
                  </label>
                  <div>
                    <SelectGlobal 
                      itens={clients}
                      buttonAll={true}
                      textSearch={`Buscar por nome do cliente`}
                      textButtonInit={`Selecione o cliente`}
                      labelKey={`nameResponsible`}
                      valueKey='id'
                      value={formik.values.idClient}
                      className={"w-100"}
                      loading={loadingClients}
                      onChange={formik.handleChange("idClient")}
                    />
                  </div>
                </div>
              </div>
          </div>
        )}

        {/*end::Form Group */}

        {/*begin::Form Group */}
        {/*end::Form Group */}
      </div>
    </div>
  )
}

export {StepModal}

